module.exports = __webpack_public_path__ + "static/section2-e3b82edee2bb1bcfa8d9c199cadf5a65.png";